import { MapPin, Globe } from "lucide-react";
import { BUSINESS } from "../data/business";

export const LocationSection = () => {
    return (
        <section id="localizacao" data-testid="location-section" className="relative py-24 lg:py-36 bg-slate-900 overflow-hidden">
            <div className="absolute -top-32 -right-32 w-[460px] h-[460px] rounded-full gold-glow animate-drift pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400" data-testid="location-eyebrow">
                        Onde atendemos
                    </p>
                    <h2 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-white" data-testid="location-title">
                        Escritório em São Paulo. Clientes no Brasil inteiro.
                    </h2>
                    <div className="mt-10 space-y-6">
                        <div className="flex gap-4" data-testid="location-office">
                            <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-white/10 border border-white/20 text-amber-400 shrink-0">
                                <MapPin className="w-6 h-6" />
                            </span>
                            <div>
                                <h3 className="text-lg font-semibold text-white">Higienópolis, São Paulo</h3>
                                <p className="mt-1 text-sm text-slate-300 leading-relaxed">{BUSINESS.address}</p>
                            </div>
                        </div>
                        <div className="flex gap-4" data-testid="location-online">
                            <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-white/10 border border-white/20 text-amber-400 shrink-0">
                                <Globe className="w-6 h-6" />
                            </span>
                            <div>
                                <h3 className="text-lg font-semibold text-white">Atendimento online em todo o Brasil</h3>
                                <p className="mt-1 text-sm text-slate-300 leading-relaxed">
                                    Sua contabilidade resolvida por WhatsApp, e-mail e reuniões online — sem sair da sua cidade.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
